import RetailReportPage from 'pages/RetailReports/RetailReportPage';
import RetailAnalyticsPage from 'pages/RetailReports/RetailAnalyticsPage';
import { ANALYTICS_IDS } from 'pages/RetailReports/retailAnalyticsData';
import EmployeeMonthlyIncomePage from 'pages/RetailReports/EmployeeMonthlyIncomePage';
import SalesTransactionReportPage from 'pages/RetailReports/SalesTransactionReportPage';
import InventorySalesByStoreReportPage from 'pages/RetailReports/InventorySalesByStoreReportPage';
import SalesHierarchyReportPage from 'pages/RetailReports/SalesHierarchyReportPage';
import { EmployeeProductSalesReportPage, ProductSalesReportPage } from 'pages/RetailReports/ProductSalesReportPage';
import { getRetailReportPermissions, RETAIL_REPORTS } from 'pages/RetailReports/reportConfigs';

const retailReportsRoute = RETAIL_REPORTS.map((report) => {
  const reportPermissions = getRetailReportPermissions(report);
  const reportComponents = {
    'sales-hierarchy': SalesHierarchyReportPage,
    'employee-monthly-income': EmployeeMonthlyIncomePage,
    'employee-product-sales': EmployeeProductSalesReportPage,
    'product-sales': ProductSalesReportPage,
    transactions: SalesTransactionReportPage,
    'inventory-sales-by-store': InventorySalesByStoreReportPage,
  };

  return {
    path: report.path,
    exact: true,
    name: report.name,
    function: reportPermissions.length ? reportPermissions : 'MENU_REPORT',
    any: reportPermissions.length > 1,
    allowLoggedIn: Boolean(report.allowLoggedIn),
    component: ANALYTICS_IDS.includes(report.id) ? RetailAnalyticsPage : reportComponents[report.id] || RetailReportPage,
  };
});

export default retailReportsRoute;
